<template>
  <div class="checkbox">
    <input :id="inputId?inputId:label" type="checkbox"
      :class="{error : validationError}"
      v-model="picked"
      :value="valueLabel"
      :disabled="disabled">
    <label :class="['subhead', isBold ? 'bold' : '']" :for="inputId?inputId:label" @click.stop="buttonClicked">{{label}}</label>
    <slot name="additional" />
  </div>
</template>

<script>
import * as validationLib from '@/lib/validation/'
const {
  helpers,
  validate
} = validationLib
export default {
  name: 'adx-checkbox',
  props: {
    label: {
      required: false,
    },
    value: {
      required: false,
      default: false
    },
    error: {
      required: false
    },
    validation: {
      required: false
    },
    valueLabel: {
      required: false
    },
    disabled: {
      required: false,
      default: false
    },
    isInitial: {
      required: false
    },
    inputId: {
      required: false,
      default: ''
    },
    isBold: {
      required: false,
      default: false
    }
  },
  data() {
    return {
      initial: true,
      picked: '',
      valid: undefined,
      message: undefined
    }
  },
  mounted() {
    this.picked = this.value
    if (!this.validation) {
      this.$emit(`update:isInitial`, false)
    }
  },
  methods: {
    validateInput(value) {
      if (this.validation) {
        const { valid, message } = validate(this.validation, value, this.id?this.id:this.label)
        if(valid) {
          this.$emit(`update:value`, value)
          this.$emit(`update:error`, false)
        } else {
          this.$emit(`update:value`, ``)
          this.$emit(`update:error`, !valid)
        }
        this.valid = valid
        this.message = message
      } else {
        this.$emit(`update:value`, value)
        this.$emit(`update:error`, false)
      }
      this.$emit(`update:isInitial`, false)
    },
    buttonClicked() {
      this.$emit(`buttonClicked`)
    }
  },
  watch: {
    picked() {
      this.validateInput(this.picked)
    },
    value: function () {
      this.picked = this.value
    }
  },
  computed: {
    validationError: function () {
      if (this.error) return this.error
      return this.valid === undefined ? false : !this.valid
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>